import {select} from 'redux-saga/effects';
import {
    getCurrentPage,
    isCartPage as isCartPageSelector,
    isInsuranceSuccessPage as isInsuranceSuccessPageSelector,
} from 'selectors/app/app';

export const CART_PAGE = 'cart';
export const INSURANCE_SUCCESS_PAGE = 'insuranceSuccessPage';

/**
 * Get page type
 * @returns {string} type page
 */
export function* getTypePage() {
    const {page} = yield select(getCurrentPage);

    const isCartPage = yield select(isCartPageSelector);
    if (isCartPage) return CART_PAGE;

    const isInsuranceSuccessPage = yield select(isInsuranceSuccessPageSelector);
    if (isInsuranceSuccessPage) return INSURANCE_SUCCESS_PAGE;

    return page;
}
